var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9478 13.9095C13.2313 13.9095 13.5793 11.8795 13.5793 11.8795H9.29351L9.59449 16.9923L7.26349 16.7667L7.41388 11.8043L3.12623 11.8041C3.12623 11.8041 2.97482 13.6842 5.83502 13.6842L4.18077 20L2.00036 18.9473C2.00036 18.9473 1.99955 14.6615 2.00036 10.827C2.00199 2.03307 14.7845 1.85171 14.7826 10.6014C14.7816 15.8646 14.8578 18.7217 14.8578 18.7217L12.5266 19.9998L10.9478 13.9095ZM6.81233 2.40598L6.28598 0L10.5718 0.075194L9.97025 2.40598H6.81233Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.3062a56779732e74f035b9d278b3096f.svg";
export { ForwardRef as ReactComponent };